<ez-section>
  <ez-block>
    <div class="phms-intake-submission-list">
      <div class="page-header">
        <div>
          <h2>{{ pageTitle }}</h2>
          <p class="page-subtitle">{{ pageSubtitle }}</p>
        </div>
        <div class="page-header__actions">
          <ez-button
            severity="secondary"
            [buttonText]="'Refresh'"
            [disabled]="isLoading()"
            (click)="refresh()"
          ></ez-button>
          <a class="primary-link" [routerLink]="['/phms/intake/create-inmate']">{{ subjectText.addAction() }}</a>
          <a class="primary-link" [routerLink]="['/phms/intake']">New intake</a>
        </div>
      </div>

      <p class="loading-text" *ngIf="isLoading()" role="status" aria-live="polite">
        Loading intake submissions...
      </p>

      <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
        <p>{{ error.title }}</p>
        <ul>
          <li *ngFor="let message of error.messages">{{ message }}</li>
        </ul>
      </div>

      <ng-container *ngIf="!isLoading() && !errorState()">
        <p class="meta-row" *ngIf="hasIntakeSubmissions()">
          Showing {{ intakeSubmissions().length }} of {{ totalCount() }} intake submissions.
        </p>

        <table class="intake-submission-table" *ngIf="hasIntakeSubmissions(); else emptyState">
          <thead>
            <tr>
              <th scope="col">Last Name</th>
              <th scope="col">First Name</th>
              <th scope="col">{{ identifierLabel() }}</th>
              <th scope="col">{{ programScopeKeyLabel() }}</th>
              <th scope="col">{{ operationalText.status() }}</th>
              <th scope="col">Received</th>
              <th scope="col" class="actions-col">Open</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let intakeSubmission of intakeSubmissions()">
              <td>{{ lastNameOf(intakeSubmission) }}</td>
              <td>{{ firstNamesOf(intakeSubmission) }}</td>
              <td>{{ intakeSubmission.incarceratedPersonIdentifier }}</td>
              <td>{{ intakeSubmission.programScopeKey }}</td>
              <td>{{ intakeSubmission.intakeStatusCode }}</td>
              <td>{{ intakeSubmission.intakeAtUtc | date: 'medium' }}</td>
              <td class="actions-col">
                <a
                  [routerLink]="['/phms/intake-submissions', intakeSubmission.id]"
                  [attr.aria-label]="'Open intake submission ' + intakeSubmission.incarceratedPersonDisplayName"
                >
                  View
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #emptyState>
          <p class="empty-state" role="status">
            No intake submissions have been recorded yet. Submit a new intake to populate the list.
          </p>
        </ng-template>
      </ng-container>
    </div>
  </ez-block>
</ez-section>

